import { MethodologyType } from "../methodology/types";
import { ENERGY_SOURCE_KEY } from "./energy-source-key";
// Maps the BISKO ids from the db
// `as const satisfies` preserves literal types so that downstream constants derived from
// `.id` retain their narrow string literal type instead of widening to `string`.
export const BISKO_METHODOLOGY_LOOKUP_MAP = {
    type: MethodologyType.BISKO,
    id: "zvq8xejg64m4s2gwj7r9nfd9",
    sectors: {
        STATIONARY_ENERGY: {
            id: "y5rjq7nunlt1qosz6njjx3jp",
            title: "Stationäre Energie",
            subsectors: {
                INDUSTRY: {
                    id: "at44xd3jo7l70xyc3b8amkhf",
                    title: "Industry",
                },
                COMMERCE_TRADE_SERVICES: {
                    id: "gjoelrx4o7rc4atcvan2xwni",
                    title: "GHD",
                },
                HOUSEHOLDS: {
                    id: "unl9nvaxfiwhi3q1aky7r4vg",
                    title: "Haushalte",
                },
                PUBLIC_BUILDINGS: {
                    id: "ajxu2fd6qm06zuwc00r1erel",
                    title: "Kommunale Einrichtungen",
                },
            },
            energySources: {
                BIOGAS_STATIONARY_ENERGY: {
                    id: "rdadnpb59u5gypdot24a2shl",
                    title: "Biogas",
                    key: ENERGY_SOURCE_KEY.BIOGAS,
                },
                BIOMASS: {
                    id: "xs0em6yxz64gq6is5y79jbal",
                    title: "Biomasse",
                    key: ENERGY_SOURCE_KEY.BIOMASS,
                },
                LIGNITE: {
                    id: "lke4onp5sr9q6ypgw7pho1sx",
                    title: "Braunkohle",
                    key: ENERGY_SOURCE_KEY.LIGNITE,
                },
                NATURAL_GAS: {
                    id: "gwxp4qa6tr6qid0o5rem6boy",
                    title: "Erdgas",
                    key: ENERGY_SOURCE_KEY.NATURAL_GAS,
                },
                DISTRICT_HEATING: {
                    id: "lpv080f56jtik30m8f1m3voa",
                    title: "Fernwärme",
                    key: ENERGY_SOURCE_KEY.DISTRICT_HEATING,
                },
                LIQUID_GAS: {
                    id: "lhitxwsjdowahe6m1mssn3di",
                    title: "Flüssiggas",
                    key: ENERGY_SOURCE_KEY.LPG_STATIONARY,
                },
                HEATING_ELECTRICITY: {
                    id: "dcmwn0s5w67dhh3wx2bg9f43",
                    title: "Heizstrom",
                    key: ENERGY_SOURCE_KEY.ELECTRICITY_FOR_HEATING,
                },
                HEATING_OIL: {
                    id: "my5kugikno4x13qayhrlmfka",
                    title: "Heizöl",
                    key: ENERGY_SOURCE_KEY.HEATING_OIL,
                },
                LOCAL_HEATING: {
                    id: "naivjp8a72zbdfg0dzka5kh8",
                    title: "Nahwärme",
                    key: ENERGY_SOURCE_KEY.LOCAL_HEATING,
                },
                SOLAR_THERMAL: {
                    id: "kjfn4a6zynhvnxzqkf0zb79a",
                    title: "Solarthermie",
                    key: ENERGY_SOURCE_KEY.SOLAR_THERMAL,
                },
                OTHER_RENEWABLE: {
                    id: "fktwpip6u4obl8mmdpd0az8a",
                    title: "Sonstige Erneuerbare",
                    key: ENERGY_SOURCE_KEY.OTHER_RENEWABLES,
                },
                OTHER_CONVENTIONAL: {
                    id: "s0qnkk8dgw1iiwnfenc9jrv6",
                    title: "Sonstige Konventionelle",
                    key: ENERGY_SOURCE_KEY.OTHER_CONVENTIONAL,
                },
                HARD_COAL: {
                    id: "z2iulkreqj4qj5zkxo94fgyk",
                    title: "Steinkohle",
                    key: ENERGY_SOURCE_KEY.HARD_COAL,
                },
                ELECTRICITY: {
                    id: "zrugky7ttlvu5qk0uagv2oj9",
                    title: "Strom",
                    key: ENERGY_SOURCE_KEY.ELECTRICITY,
                },
                AMBIENT_HEAT: {
                    id: "hd4dokf7pi7fifb8uni1rfdt",
                    title: "Umweltwärme",
                    key: ENERGY_SOURCE_KEY.ENVIRONMENTAL_HEAT,
                },
            },
        },
        TRANSPORTATION: {
            id: "spzzazg3jtnu2xoagttomiry",
            title: "Verkehr",
            subsectors: {
                TRANSIT_BUS: {
                    id: "bxfjerk0ynlv5ogoe84dg960",
                    title: "Linienbus",
                },
                TRAM_METRO: {
                    id: "cmxbpni63gf62w440oji3x0v",
                    title: "Stadt-, Straßen- und U-Bahn",
                },
                AVIATION: {
                    id: "fr7ow82e9v9we2blzsk9tmoc",
                    title: "Flugverkehr",
                },
                LONG_DISTANCE_RAIL: {
                    id: "fw1059idw1u7egs9wl1lliv7",
                    title: "Schienenpersonenfernverkehr",
                },
                MOTORIZED_TWO_WHEELERS: {
                    id: "gamaxb1tf3e8w7bct7o3xiij",
                    title: "Motorisierte Zweiräder",
                },
                INLAND_SHIPPING: {
                    id: "hpkre62mv1x1z5an6av1ahxi",
                    title: "Binnenschifffahrt",
                },
                HEAVY_COMMERCIAL_VEHICLES: {
                    id: "pz4dcnfyp4olodsrffizve6r",
                    title: "Schwere Nutzfahrzeuge",
                },
                COACHES: {
                    id: "sczt0j1hgzfjq1gjoj6s2p2o",
                    title: "Reisebusse",
                },
                LOCAL_RAIL: {
                    id: "snwjj3fstc3p86vhybfc55q2",
                    title: "Schienenpersonennahverkehr",
                },
                PASSENGER_CARS: {
                    id: "t59hs93ye23zevh9n5scljlw",
                    title: "Personenkraftwagen",
                },
                LIGHT_COMMERCIAL_VEHICLES: {
                    id: "yufnzm5giuyxapl935uinvqd",
                    title: "Leichte Nutzfahrzeuge",
                },
                RAIL_FREIGHT: {
                    id: "zahriuyog9szebxjpzkw1mpq",
                    title: "Schienengüterverkehr",
                },
            },
            energySources: {
                ELECTRICITY: {
                    id: "zrugky7ttlvu5qk0uagv2oj9",
                    title: "Strom",
                    key: ENERGY_SOURCE_KEY.ELECTRICITY,
                },
                GASOLINE: {
                    id: "hd4dokf7pi7fifb8uni1rfdg",
                    title: "Benzin",
                    key: ENERGY_SOURCE_KEY.GASOLINE_FOSSIL,
                },
                BIO_GASOLINE: {
                    id: "pvvkz4e0x3k0eiqzuy8atwdd",
                    title: "Biobenzin",
                    key: ENERGY_SOURCE_KEY.GASOLINE_BIOGENIC,
                },
                DIESEL: {
                    id: "l1cerli2zdzgvdqrsiy8hdv8",
                    title: "Diesel",
                    key: ENERGY_SOURCE_KEY.DIESEL_FOSSIL,
                },
                DIESEL_BIOGENIC: {
                    id: "vao8o87ktc5upodv91znfnr3",
                    title: "Diesel biogen",
                    key: ENERGY_SOURCE_KEY.DIESEL_BIOGENIC,
                },
                KEROSENE: {
                    id: "m9hdcctw8oxguinl26ze2s2r",
                    title: "Kerosin",
                    key: ENERGY_SOURCE_KEY.KEROSENE,
                },
                BIO_CNG: {
                    id: "c455t6hztfxrse1rjo9m9e6i",
                    title: "Bio-CNG",
                    key: ENERGY_SOURCE_KEY.BIOGAS_TRANSPORT,
                },
                LPG: {
                    id: "l35s1ykikz9khecrguj8cx40",
                    title: "LPG",
                    key: ENERGY_SOURCE_KEY.LPG_TRANSPORT,
                },
                NATURAL_GAS_CNG_LNG: {
                    id: "l35s1ykikz9khecrguj8cx41",
                    title: "Erdgas (CNG + LNG)",
                    key: ENERGY_SOURCE_KEY.NATURAL_GAS_CNG_LNG,
                },
            },
        },
    },
};
